export default __webpack_public_path__ + "static/media/phuket-surgery.0160425e.png";